import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/programming-language-dart.svg?component
var programming_language_dart_exports = /* @__PURE__ */ __exportAll({
	default: () => programming_language_dart_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 50 50"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "m7.91 9.32.09.09V35.3l-5.09-5.09a6.22 6.22 0 0 1-1.27-6.92zM35.3 8H9.41l-.09-.09 13.97-6.27a6.22 6.22 0 0 1 6.92 1.27zm2.29 31H11.71l-.54-.54A4 4 0 0 1 10 35.63V11.41zm-23.88 2H39v6c0 .55-.45 1-1 1H21.1c-.27 0-.52-.11-.71-.29l-4.7-4.7.02-.02zM48 21.1V38c0 .55-.45 1-1 1h-6.58L11.41 10h24.22c1.07 0 2.07.42 2.83 1.17l4.53 4.54.02-.02 4.7 4.7c.18.19.29.44.29.71" }, null, -1)])]);
}
var programming_language_dart_default = { render: render$1 };
//#endregion
export { programming_language_dart_default as default, programming_language_dart_exports, render$1 as render };

//# sourceMappingURL=programming-language-dart.svg.virtual.js.map